import { makeAutoObservable } from "mobx";
import { PProductError } from "./PProductError";
import { PProductUnavailabilityDetails } from "./PProductInstanceUnavailabilityDetails";
export class PProductInstanceCreatorPart {
    constructor(params) {
        this.domain = params.domain;
        this.productInstancePartAvailabilityService =
            params.productInstancePartAvailabilityService;
        this.possibleProductTypes = params.possibleProductTypes;
        this.productType = params.productType;
        this.partConfigCreator = params.partConfigCreator;
        this.restaurant = params.restaurant;
        makeAutoObservable(this);
    }
    get productTypeId() {
        return this.productType.id;
    }
    get productName() {
        return this.productType.name;
    }
    get productBaseIngredients() {
        return this.productType.baseIngredients;
    }
    get productTags() {
        return this.productType.tags;
    }
    get productAllergens() {
        return this.productType.allergens;
    }
    get productPhoto() {
        return this.productType.photo;
    }
    get productDescription() {
        return this.productType.description;
    }
    get productFreeModifierItemsCount() {
        return this.productType.freeModifierItemsCount;
    }
    get depositIcon() {
        return this.productType.depositIcon;
    }
    get availability() {
        return this.productInstancePartAvailabilityService.availability(this.domain.productInstancePart);
    }
    get unavailabilityDetails() {
        return new PProductUnavailabilityDetails({
            availability: this.availability,
            restaurant: this.restaurant,
        });
    }
    get isSubmitVisible() {
        const { error } = this.unavailabilityDetails;
        if (error === null) {
            return true;
        }
        switch (error.type) {
            case "VisibilityUnavailability":
            case "TemporarilyUnavailable":
                return false;
            case "PreorderUnavailability":
            case "ScheduleUnavailability":
            case "ParametersUnavailability":
            case "UnknownUnavailability":
                return true;
        }
    }
    get error() {
        const { parametersDetails, error } = this.unavailabilityDetails;
        if (error !== null && error.type === "ParametersUnavailability") {
            return PProductError.unavailable(parametersDetails);
        }
        return null;
    }
    validate() {
        this.partConfigCreator.validate();
    }
    get temporarilyUnavailableIngredients() {
        return this.partConfigCreator.temporarilyUnavailableIngredients;
    }
}
